module.exports = __webpack_public_path__ + "8a5d4bbba4c1abd46ff977c5349e8f75.png";